// 1. On définit la logique de mise à jour dans une fonction nommée
// Cela permet de l'appeler directement ET de la passer au "addEventListener"
function handleScrollUpdate() {
    const scrollPosition = window.scrollY;
    const header = document.getElementById('header');
    const logoImages = document.querySelectorAll('.pdw-logo');

    // Ajout/Retrait de la classe sur le Body et le Header
    if (scrollPosition > 50) { // J'ai mis > 50 pour éviter que ça clignote au tout début
        document.body.classList.add('scrolled');
        if (header) header.classList.add('active');
    } else {
        document.body.classList.remove('scrolled');
        if (header) header.classList.remove('active');
    }

    // Gestion des Logos
    logoImages.forEach((logo) => {
        let currentSrc = logo.src;

        if (scrollPosition > 50) {
            // Vers version DARK
            if (!currentSrc.includes('-dark')) {
                logo.src = currentSrc.replace('.svg', '-dark.svg');
            }
        } else {
            // Vers version NORMALE
            if (currentSrc.includes('-dark')) {
                logo.src = currentSrc.replace('-dark.svg', '.svg');
            }
        }
    });
}

// 2. La fonction d'initialisation (Celle appelée par Barba et au chargement)
window.initPdwScrolled = function () {
    // A. On exécute la fonction tout de suite (au cas où on arrive sur une page déjà scrollée)
    handleScrollUpdate();

    // B. IMPORTANT : On supprime l'ancien écouteur avant d'en mettre un nouveau
    // Sinon, après 10 pages visitées, tu auras 10 fois le script qui tourne en même temps !
    window.removeEventListener('scroll', handleScrollUpdate);

    // C. On ajoute l'écouteur pour le scroll
    window.addEventListener('scroll', handleScrollUpdate);
};

// 3. Lancement au premier chargement du site (Hors Barba)
document.addEventListener("DOMContentLoaded", () => {
    window.initPdwScrolled();
});